export default class SortableColumn {
    constructor(model) {
        this.title = "";
        this.fieldName = "";
        this.visible = true;
        if (!model)
            return;
        this.title = model["title"] ? model["title"] : "";
        this.fieldName = model["fieldName"] ? model["fieldName"] : "";
        this.visible = model["visible"] ? model["visible"] : true;
    }
}
